type TrackingEvent = {
  event: string
  extra?: object
  userId?: number
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'i_have_an_issue'

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs): TrackingEvent => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type InboxSupportFeedbackEventsBaseArgs = {
  threadId: string
  helpCenterSessionId: string
}

type InboxActionButtonEventsArgs = InboxSupportFeedbackEventsBaseArgs & {
  supportType: string
}

export const continueConversationClicked = (args: InboxActionButtonEventsArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    support_type: args.supportType,
  }

  return {
    event: 'support_conversation_actions.continue_conversation_clicked',
    extra,
  }
}
